/**
 * The bar pinned above every dashboard screen while an ADMIN is viewing as someone
 * (see @/lib/view-as). It says whose eyes the screen is seen through, that nothing can be
 * changed, and offers the one way back. Renders nothing outside View As.
 */

import { Eye } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useStopViewAs, useViewAsState } from "@/hooks/use-view-as";

export function ViewAsBanner() {
  const viewAs = useViewAsState();
  const stop = useStopViewAs();
  if (!viewAs) return null;

  const { user } = viewAs;
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex shrink-0 flex-wrap items-center gap-x-3 gap-y-1 border-b border-warning-300 bg-warning-100 px-4 py-2 text-sm text-warning-950 dark:border-warning-800 dark:bg-warning-950 dark:text-warning-100"
    >
      <Eye className="h-4 w-4 shrink-0" aria-hidden />
      <p className="min-w-0 flex-1">
        Viewing as <span className="font-semibold">{user.name}</span>
        <span className="text-warning-800 dark:text-warning-300">
          {" "}
          · {user.role} · {user.email} · read-only
        </span>
      </p>
      <Button
        size="sm"
        variant="outline"
        className="border-warning-400 bg-transparent hover:bg-warning-200 dark:border-warning-700 dark:hover:bg-warning-900"
        disabled={stop.isPending}
        onClick={() => stop.mutate()}
      >
        {stop.isPending ? "Exiting…" : "Exit View As"}
      </Button>
    </div>
  );
}
